module.exports = __webpack_public_path__ + "static/media/patrol.663583fe.mp4";